import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isEqual } from 'lodash/fp';
import { OrderItemType } from '@mews-commander/data-access';
import { ApplicationState, CommanderThunkDispatch, OrderItem } from '@mews-commander/types';
import { getSelectStateGroupedOrderItemsSelected, toggleGroupedOrderItemsSelect } from '../../../../ducks/billItems';
import {
    areAllGroupOrderItemsRebated,
    areAllOrderItemsByGroupIdClosed,
    areAllOrderItemsByGroupIdRebates,
    areSomeGroupOrderItemsRebated,
    getGroupItemsCollectiveRebateIndex,
} from '../../../../rebate/selectors/orderItems';
import {
    doAllOrderItemsHaveSameNotes,
    getGroupedOrderItemsTotal,
    getGroupedSortedOrderItems,
} from '../../../../selectors';
import { TotalAmountAndCount } from '../../../../types';
import { SelectState } from '../types';

interface StateProps {
    orderItems: OrderItem[];
    selectState: SelectState;
    totalAmountAndCount: TotalAmountAndCount;
    allItemsHaveSameNotes: boolean;
    areAllOrderItemsRebated: boolean;
    areSomeOrderItemsRebated: boolean;
    areAllOrderItemsRebates: boolean;
    areAllOrderItemsClosed: boolean;
    collectiveRebateIndex?: number;
}

interface DispatchProps {
    toggleSelect(): void;
}

interface OwnProps {
    type: OrderItemType;
    serviceId: string;
    serviceOrderId: string;
    billId: string;
    groupId: string;
    ageCategoryId?: string;
    scope: string;
    month: string;
}

export const connectOrderItemProductList = connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        orderItems: (
            state: ApplicationState,
            { serviceId, billId, serviceOrderId, groupId, ageCategoryId, type, month }: OwnProps
        ) =>
            getGroupedSortedOrderItems(state, {
                groupId,
                serviceId,
                serviceOrderId,
                billId,
                ageCategoryId,
                type,
                month,
            }),
        allItemsHaveSameNotes: doAllOrderItemsHaveSameNotes,
        selectState: (
            state: ApplicationState,
            { type, serviceId, serviceOrderId, groupId, billId, ageCategoryId, scope, month }: OwnProps
        ) =>
            getSelectStateGroupedOrderItemsSelected(state, {
                type,
                serviceId,
                serviceOrderId,
                groupId,
                billId,
                ageCategoryId,
                // @ts-expect-error $TSFixMeError: Argument of type '{ type: OrderItemType; serviceId: string; serviceOrderId: string; groupId: string; billId: string; age...
                scope,
                month,
            }),
        totalAmountAndCount: (
            state: ApplicationState,
            { serviceId, billId, serviceOrderId, groupId, ageCategoryId, type, month }: OwnProps
        ) =>
            getGroupedOrderItemsTotal(state, {
                serviceId,
                serviceOrderId,
                groupId,
                billId,
                ageCategoryId,
                type,
                month,
            }),
        areAllOrderItemsRebated: areAllGroupOrderItemsRebated,
        areSomeOrderItemsRebated: areSomeGroupOrderItemsRebated,
        areAllOrderItemsRebates: areAllOrderItemsByGroupIdRebates,
        areAllOrderItemsClosed: areAllOrderItemsByGroupIdClosed,
        collectiveRebateIndex: getGroupItemsCollectiveRebateIndex,
    }),
    (
        dispatch: CommanderThunkDispatch,
        { type, serviceId, serviceOrderId, billId, groupId, ageCategoryId, scope, month }
    ) => ({
        toggleSelect: () =>
            dispatch(
                toggleGroupedOrderItemsSelect({
                    type,
                    serviceId,
                    serviceOrderId,
                    groupId,
                    billId,
                    ageCategoryId,
                    scope,
                    month,
                })
            ),
    }),
    null,
    {
        areStatePropsEqual: isEqual,
    }
);
